// src/ui/overlays/VersionOverlay.tsx — D-12 / PWA-08 support artifact.
//
// Reads __APP_VERSION__ and __GIT_HASH__ injected at build time by Vite's
// `define` (see vite.config.ts). Positioned bottom-right, amber (#e8a838) at
// 40% opacity, pointer-events: none so it never intercepts taps. aria-hidden
// since it's a support artifact, not content.

import type { JSX } from 'react';
import './overlays.css';

export function VersionOverlay(): JSX.Element {
  const version =
    typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';
  const hash = typeof __GIT_HASH__ === 'string' ? __GIT_HASH__ : 'unknown';
  return (
    <div
      className="version-overlay"
      data-testid="version-overlay"
      aria-hidden="true"
    >
      v{version}-{hash}
    </div>
  );
}
